import { schema } from 'normalizr'

const tableProductVote = new schema.Entity('tableProductVotes')

export default tableProductVote
